import { buildValueMap } from "./utils";

export const TermsDef = {
    PP: { value: 1, label: "PP" },
    Net15: { value: 2, label: "Net15" },
    Net30: { value: 3, label: "Net30" },
    Net45: { value: 4, label: "Net45" },
    Net60: { value: 5, label: "Net60" },
    Net90: { value: 6, label: "Net90" },
    Net120: { value: 7, label: "Net120" }
};

export const TagsDef = {
    Sales: { value: 1, label: "Sales" },
    CustomerService: { value: 2, label: "Customer Service" },
    Purchasing: { value: 3, label: "Purchasing" },
    Quality: { value: 4, label: "Quality" },
    Shipping: { value: 5, label: "Shipping" },
    Warehouse: { value: 6, label: "Warehouse" },
    Accounting: { value: 7, label: "Accounting" },
    Production: { value: 8, label: "Production" }
};

export const UserProfileTypeDef = {
    Inventory: { value: 1, label: "Inventory" },
    OpenPOReport: { value: 2, label: "Open PO Report" },
    OpenSOReport: { value: 3, label: "Open SO Report" },
    SalesReport: { value: 4, label: "Sales Report" },
    LastSales: { value: 5, label: "Last Sales" },
    SOPickingReport: { value: 6, label: "SO Picking Report" },
    SOFulfillmentReport: { value: 7, label: "SO Fulfillment Report" },
    OpenSOReportByItem: { value: 8, label: "Open SO Report By Item" }
};

export const GLImpactTypeDef = {
    Receipt: { value: 1, label: "Receipt" },
    Bill: { value: 2, label: "Bill" },
    SOFulfillment: { value: 3, label: "SO Fulfillment" },
    Invoice: { value: 4, label: "Invoice" },
    BankTransaction: { value: 5, label: "Bank Transaction" },
    WoFulfillment: { value: 6, label: "WO Fulfillment" },
    InventoryAdjustment: { value: 7, label: "Inventory Adjustment" }
};

export const GLActionDef = {
    Increase: { value: 1, label: "Increase" },
    Decrease: { value: 2, label: "Decrease" }
};

export const Terms = buildValueMap(TermsDef);
export const Tags = buildValueMap(TagsDef);
export const UserProfileType = buildValueMap(UserProfileTypeDef);
export const GLImpactType = buildValueMap(GLImpactTypeDef);
export const GLAction = buildValueMap(GLActionDef);
